import { useState, useRef } from 'react';
import Vapi from '@vapi-ai/web';
import { Phone, PhoneOff, Mic, MicOff, X } from 'lucide-react';

const KEY = process.env.REACT_APP_VAPI_PUBLIC_KEY;
const ID = process.env.REACT_APP_VAPI_ECHO_ASSISTANT_ID;

let vapi = null;

export default function TalkToEcho() {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState('idle');
  const [muted, setMuted] = useState(false);
  const bound = useRef(false);

  if (!vapi) vapi = new Vapi(KEY);

  if (!bound.current) {
    bound.current = true;
    vapi.on('call-start', () => setStatus('active'));
    vapi.on('call-end', () => setStatus('idle'));
    vapi.on('error', () => setStatus('idle'));
  }

  const start = async () => {
    setStatus('connecting');
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      await vapi.start(ID);
    } catch { setStatus('idle'); }
  };

  const stop = () => { vapi.stop(); setStatus('idle'); };

  if (!open) {
    return (
      <button data-testid="talk-to-echo-button" onClick={() => setOpen(true)}
        style={{ position:'fixed',bottom:24,left:24,zIndex:50,display:'flex',alignItems:'center',gap:10,padding:'12px 20px',borderRadius:999,background:'linear-gradient(135deg,#D4AF37,#b8941f)',border:'none',cursor:'pointer',boxShadow:'0 8px 32px rgba(212,175,55,0.4)',color:'#040F49',fontWeight:700,fontSize:14 }}>
        <Phone size={18}/> Talk to Echo
      </button>
    );
  }

  return (
    <div data-testid="echo-call-panel" style={{ position:'fixed',bottom:24,left:24,zIndex:50,width:300,borderRadius:16,overflow:'hidden',background:'#0A1244',border:'1px solid rgba(212,175,55,0.25)',boxShadow:'0 20px 60px rgba(0,0,0,0.6)' }}>
      <div style={{ padding:'16px 20px',display:'flex',alignItems:'center',justifyContent:'space-between',borderBottom:'1px solid rgba(212,175,55,0.15)' }}>
        <div>
          <div style={{ color:'#fff',fontWeight:600,fontSize:14 }}>Supervisor Echo</div>
          <div style={{ color:'#6b7280',fontSize:12 }}>{status==='idle'?'Ready':status==='connecting'?'Connecting...':'Speaking...'}</div>
        </div>
        <button onClick={()=>{stop();setOpen(false)}} style={{background:'none',border:'none',color:'#6b7280',cursor:'pointer'}}><X size={16}/></button>
      </div>
      <div style={{ padding:20 }}>
        {status==='idle'&&<button data-testid="echo-start-call" onClick={start} style={{width:'100%',padding:14,borderRadius:12,border:'none',cursor:'pointer',background:'linear-gradient(135deg,#D4AF37,#b8941f)',color:'#040F49',fontWeight:700,fontSize:14,display:'flex',alignItems:'center',justifyContent:'center',gap:8}}><Phone size={16}/>Start Conversation</button>}
        {status==='connecting'&&<div style={{textAlign:'center',color:'#D4AF37',fontSize:14,padding:10}}>Connecting...</div>}
        {status==='active'&&<div style={{display:'flex',gap:8}}>
          <button onClick={()=>{vapi.setMuted(!muted);setMuted(m=>!m)}} style={{flex:1,padding:12,borderRadius:12,display:'flex',alignItems:'center',justifyContent:'center',gap:6,border:`1px solid ${muted?'rgba(239,68,68,0.3)':'rgba(255,255,255,0.1)'}`,background:muted?'rgba(239,68,68,0.15)':'rgba(255,255,255,0.08)',color:muted?'#ef4444':'#9ca3af',cursor:'pointer',fontSize:13}}>{muted?<><MicOff size={14}/>Unmute</>:<><Mic size={14}/>Mute</>}</button>
          <button onClick={stop} style={{flex:1,padding:12,borderRadius:12,display:'flex',alignItems:'center',justifyContent:'center',gap:6,border:'1px solid rgba(239,68,68,0.3)',background:'rgba(239,68,68,0.2)',color:'#ef4444',cursor:'pointer',fontSize:13,fontWeight:600}}><PhoneOff size={14}/>End</button>
        </div>}
      </div>
    </div>
  );
}
